import React, { useState, useCallback, FormEvent } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";

import getValidationErrors from "./../../utils/getValidationErrors";
import { getPostLoginRedirectPath } from "./../../utils/authRedirect";
import { Form, InputForm } from "./styles";
import { useAuth } from "../../hooks/auth";
import { hasScheduleRequest, getScheduleRequest } from "../../utils/scheduleUtils";
import { getPostLoginHomePath } from "../../utils/canManageSubLogins";


interface IErrors {
  email?: string;
  password?: string;
}

type LocationState = {
  from?: string;
};

const FormToLoginPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { signIn } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<IErrors>({});
  const [apiError, setApiError] = useState("");

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      setLoading(true);
      setErrors({});
      setApiError("");

      try {
        const schema = Yup.object().shape({
          email: Yup.string()
            .required("E-mail obrigatório")
            .email("Coloque um e-mail válido"),
          password: Yup.string().required("Senha obrigatória"),
        });

        await schema.validate({ email, password }, { abortEarly: false });

        await signIn({ email: email.trim(), password });

        const redirectPath = getPostLoginRedirectPath(
          location.search,
          location.state?.from
        );

        if (redirectPath) {
          history.replace(redirectPath);
          return;
        }

        if (hasScheduleRequest()) {
          const scheduleRequest = getScheduleRequest();
          history.push(`/schedule/${scheduleRequest.propertyId}`, scheduleRequest.state);
          return;
        }

        const storedUserRaw = localStorage.getItem("@7Cantos:user");
        const storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;

        history.push(getPostLoginHomePath(storedUser));
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          setErrors(getValidationErrors(err));
        } else {
          setApiError("E-mail ou senha inválidos");
        }
      } finally {
        setLoading(false);
      }
    },
    [signIn, history, email, password, location.search, location.state]
  );

  return (
    <>
      <Form onSubmit={handleSubmit}>
        {!!apiError && <h3>{apiError}</h3>}

        <p>
          E-mail: <span style={{ color: "#FF3838" }}>{errors.email}</span>
        </p>
        <InputForm
          hasError={!!errors.email || !!apiError}
          type="text"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <p>
          Senha: <span style={{ color: "#FF3838" }}>{errors.password}</span>
        </p>
        <InputForm
          hasError={!!errors.password || !!apiError}
          type="password"
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {!loading ? (
          <button type="submit">ENTRAR</button>
        ) : (
          <label>Carregando...</label>
        )}
      </Form>
    </>
  );
};

export default FormToLoginPage;
